import location from '@paypalcorp/instance-location';

export const appendCdnHostName = (url) => {
  const protocol = window.location.protocol;
  return `${protocol}//${location.getCdnHostName()}${url}`;
};
